import PropTypes from 'prop-types';
import { experimentalStyled, alpha } from '@mui/material/styles';

/**
 * Badge de statut « soft ».
 *
 * L'ancienne version peignait un aplat saturé plein cadre : dans une
 * liste, dix statuts colorés attiraient l'œil autant que la donnée
 * elle-même. On garde la même sémantique de couleur, mais en teinte
 * douce + texte coloré, façon badge moderne.
 */
const LabelRoot = experimentalStyled('span')((({ theme, styleProps }) => {
  const paletteEntry = theme.palette[styleProps.color] || {};
  const isDark = theme.palette.mode === 'dark';
  // `color="action"` est utilisé par endroits : cette entrée de palette
  // n'a pas de `main`, on retombe alors sur le texte secondaire.
  const main = paletteEntry.main || theme.palette.text.secondary;
  // Le texte prend la nuance foncée en thème clair (et claire en sombre)
  // pour rester lisible sur la teinte diluée du fond.
  const foreground = isDark
    ? (paletteEntry.light || main)
    : (paletteEntry.dark || main);

  return {
    alignItems: 'center',
    backgroundColor: alpha(main, isDark ? 0.2 : 0.11),
    border: `1px solid ${alpha(main, isDark ? 0.3 : 0.2)}`,
    borderRadius: 8,
    color: foreground,
    cursor: 'default',
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 700,
    justifyContent: 'center',
    letterSpacing: '0.04em',
    lineHeight: 1.5,
    minWidth: 20,
    paddingBottom: theme.spacing(0.35),
    paddingLeft: theme.spacing(0.9),
    paddingRight: theme.spacing(0.9),
    paddingTop: theme.spacing(0.35),
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };
}));

const Label = (props) => {
  const { color = 'primary', children, ...other } = props;

  const styleProps = { color };

  return (
    <LabelRoot
      styleProps={styleProps}
      {...other}
    >
      {children}
    </LabelRoot>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'success',
  ])
};

export default Label;
